import { render, staticRenderFns } from "./PixPayment.vue?vue&type=template&id=3b06a4ba&scoped=true"
import script from "./PixPayment.vue?vue&type=script&lang=js"
export * from "./PixPayment.vue?vue&type=script&lang=js"
import style0 from "./PixPayment.vue?vue&type=style&index=0&id=3b06a4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b06a4ba",
  null
  
)

export default component.exports